/**
 * Embedding similarity helpers for the live recognition test.
 */

/**
 * Standard cosine similarity between two equal-length vectors.
 * Returns a value in [−1, 1]; for unit-normed MobileNet embeddings
 * this is effectively [0, 1] in practice.
 */
export function computeCosineSimilarity(a: number[], b: number[]): number {
  let dot = 0;
  let normA = 0;
  let normB = 0;
  for (let i = 0; i < a.length; i++) {
    dot += a[i] * b[i];
    normA += a[i] * a[i];
    normB += b[i] * b[i];
  }
  const denom = Math.sqrt(normA) * Math.sqrt(normB);
  if (denom === 0) return 0;
  return dot / denom;
}

/**
 * Returns the maximum cosine similarity between `frameEmbedding` and any
 * embedding in `refs`.  Returns 0 when `refs` is empty.
 */
export function matchAgainstRefs(
  frameEmbedding: number[],
  refs: number[][],
): number {
  let best = 0;
  for (const ref of refs) {
    const sim = computeCosineSimilarity(frameEmbedding, ref);
    if (sim > best) best = sim;
  }
  return best;
}
